import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import { useLanguage } from '@/contexts/LanguageContext';

const ThemeToggle = () => {
  const { resolvedTheme, setTheme } = useTheme();
  const { language } = useLanguage();

  const toggleTheme = () => {
    setTheme(resolvedTheme === 'dark' ? 'light' : 'dark');
  };

  return (
    <button
      onClick={toggleTheme}
      className="min-w-[44px] min-h-[44px] p-2 rounded-lg bg-muted/50 hover:bg-muted transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background flex items-center justify-center"
      aria-label={language === 'es' 
        ? (resolvedTheme === 'dark' ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro')
        : (resolvedTheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode')
      }
      aria-pressed={resolvedTheme === 'dark'}
    >
      {resolvedTheme === 'dark' ? (
        <Sun className="w-5 h-5 text-foreground" aria-hidden="true" />
      ) : (
        <Moon className="w-5 h-5 text-foreground" aria-hidden="true" />
      )}
    </button>
  );
};

export default ThemeToggle;
